
export type SortBy = 'newest' | 'oldest' | 'quality_high' | 'quality_low' | 'review_score' | 'name_asc' | 'name_desc' | 'last_contacted' | 'last_contacted_asc';

export type ContactStatusFilter = 'all' | 'contacted' | 'not_contacted' | 'not_contacted_30' | 'not_contacted_60';

export interface AreaPreset {
  label: string;
  postcodes: string[];
}

export const AREA_PRESETS: AreaPreset[] = [
  { label: 'Dublin', postcodes: ['Dublin', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D6W', 'D7', 'D8', 'D9', 'D10', 'D11', 'D12', 'D13', 'D14', 'D15', 'D16', 'D17', 'D18', 'D20', 'D22', 'D24'] },
  { label: 'West Dublin', postcodes: ['D10', 'D12', 'D20', 'D22', 'D24', 'D6W'] },
  { label: 'North Dublin', postcodes: ['D1', 'D3', 'D5', 'D7', 'D9', 'D11', 'D13', 'D15', 'D17'] },
  { label: 'South Dublin', postcodes: ['D2', 'D4', 'D6', 'D8', 'D14', 'D16', 'D18'] },
  { label: 'Dublin City Centre', postcodes: ['D1', 'D2', 'D7', 'D8'] },
];

export interface LocationFilter {
  type: 'preset' | 'custom';
  preset?: AreaPreset;
  customText?: string;
}

export interface LeadFilters {
  showFavoritesOnly: boolean;
  selectedCategories: string[];
  selectedUserId: string | null;
  currentView: 'card' | 'list' | 'table';
  sortBy: SortBy;
  selectedLocation: string | null;
  locationFilter?: LocationFilter | null;
  selectedSector?: string | null;
  hasEmail?: boolean;
  contactStatus?: ContactStatusFilter;
  showDuplicatesOnly?: boolean;
}
